
import React from 'react';

const ClaimHelpers={
 
     nameFormatter: function(cell,row){
        try {
            return row.lastName + ',' + row.firstName;
        }catch(e){
            return 'ERROR';
        }

     },
      stageFormatter: function(cell, row){


        var claimStage = 'ERR';
        switch(cell){
          case 'O': claimStage =  'OPEN'; break;
          case 'A': claimStage =  'Archive'; break;
          case 'WS': claimStage =  'Waiting to Ship'; break;
          case 'WP': claimStage =  'Will Pickup'; break;
          case 'CP': claimStage =  'Closed-Picked Up'; break;
          case 'CS': claimStage =  'Closed-Shipped'; break;
          case 'LABELREQUESTED': claimStage =  'Label Requested'; break;
          case 'READYTOSHIP' : claimStage=  'READY TO SHIP'; break;
          case 'REQUESTTOSHIP' : claimStage=  'Request To Ship'; break;
          default: claimStage = 'ERR';
      
        }
        return claimStage;
      },


      statusColFormater: function(fieldValue, row, rowIdx, colIdx) {
        // fieldValue is column value
        // row is whole row object
        // rowIdx is index of row
        // colIdx is index of column
        //console.log(fieldValue);
      
        if (fieldValue==='O'){
          return "text-primary";
        }else if (fieldValue==='WS' || fieldValue==='WP'|| fieldValue==='LABELREQUESTED'|| fieldValue==='READYTOSHIP'){
          return "text-primary";
        }else if (fieldValue==='CS' || fieldValue==='CP'){
          return "text-primary";
        }else{
          return "";
        }
        //return ({'background-color':'red'});
      
      },
      

      getStatusLabel: function(statusCd){
        var claimDesc = '';
        switch(statusCd){
          case 'A' : claimDesc= 'Archived'; break; 
          case 'O' : claimDesc=  'OPEN'; break; 
          case 'WS' : claimDesc=  'Waiting To Ship'; break; 
          case 'WP' : claimDesc=  'Will Pickup'; break;
          case 'CS' : claimDesc=  'Closed-Shipped'; break;
          case 'CP' : claimDesc=  'Closed-Picked Up'; break;
          case 'LABELREQUESTED' : claimDesc=  'Label Requested'; break;
          case 'READYTOSHIP' : claimDesc=  'READY TO SHIP'; break;
          case 'REQUESTTOSHIP' : claimDesc=  'Request To Ship'; break;
          default : claimDesc=  'Open'; break;
        }
        return claimDesc;
      },

      formatDateTime: function(cell,row){
        try {
            if (cell){
                var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                let cellDate = new Date(cell);
                return cellDate.toLocaleDateString([],options) +  ' ' + cellDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
            }else{
                return  '';
            }
        }catch(e){
            return  '';

        }
      },
      linked: function(cell,row){
        if (cell){
          return 'Y';
        }else{
          return 'N';
        }
      },

      formatDate: function(cell,row){
        if (cell){
            var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            return new Date(cell).toLocaleDateString([],options);
            //return Date.parse(row.claimCreationDate);
        }
    },
     formatFoundItemLink: function(cell,row){
      try{

        if (cell){
            return (<button className="btn btn-outline-success btn-sm" type="button" alt={row.lostItemShortDescription}>View Item</button>)
       
        }
      }catch(e){

      }
  },

    formatPct : function(cell, row){
      if (cell){
        //console.log(Math.round(parseFloat(cell) * 100));
        return Math.round(parseFloat(cell) * 100)+"%"
      }
    },

    matchColFormater: function(fieldValue, row, rowIdx, colIdx) {
    
      if (fieldValue>=0){
        return "table-success text-primary";
      }else 
        return "table-warning text-primary";
     
    
    },
     formatName: function(cell, row){

  
      if (cell){
       
          return (
         
                <div className='text-left text-info' style={{fontSize:15}} ><b>{row.lastName + ', ' + row.firstName} </b></div>
         
            )

        
     
      }
    },
     formatId: function(cell,row){
      // if there are keywords, only show the first 50 characters.
      if (row.id){
        return( <small>{row.id}</small> );
      }else{
        return( <small></small> );
      }
      
    },
    formatEmail:function(cell,row){
      if (row.email){
        return( <small><a href={'mailto:' + row.email}>{row.email}</a></small> );
      }else{
        return (null)
      }
    },

    formatItemStatusCell: function(cell,row){
      let statusText= ClaimHelpers.getStatusLabel(row.status);
      let fieldValue = row.status;
      if (fieldValue==='O'){
        return(<span className="text-danger"><b>{statusText}</b></span>);
      }else if (fieldValue==='WS' || fieldValue==='WP'|| fieldValue==='LABELREQUESTED'|| fieldValue==='READYTOSHIP'){
        return(<span className="text-warning"><b>{statusText}</b></span>);
      }else if (fieldValue==='CS' || fieldValue==='CP'){
        return(<span className="text-success"><b>{statusText}</b></span>);
      }else if (fieldValue==='A'){
        return(<span className="text-muted"><b>{statusText}</b></span>);
      }else if (fieldValue==='REQUESTTOSHIP'){
        return(<span className="text-warning"><b>{statusText}</b></span>);
      }

      else{
        return "";
      }
    },
     formatCat: function(cell,row){
    
      let subCat = (row.subCat !== undefined) ? row.subCat : "";
      return(
          
          row.category + ' ' + subCat
        )
    },
    formatLocation: function(cell,row){
      if (cell){
        return(
          <div className='text-primary' style={{fontSize:'12px'}}> {cell.replace(/,/g, ', ')}  </div>
        )
      }
      
      
    },
    formatAirlineDetails:function(cell,row){
      if (row){
        return (
          <div>
          <div className='row'>
               <div className='col-6' ><span className='text-primary text-right' style={{fontSize:'13px', fontWeight:'bold'}}>Flight:</span></div>
               <div className='col'> <span className='text-info' style={{fontSize:'13px', fontWeight:'bold'}}><b>{row.flightNumber} </b></span> </div>
          </div>
          <div className='row'>
               <div className='col-6' style={{width:200}}><span className='text-primary text-right' style={{fontSize:'13px'}}>Seat/Row:</span> </div>
               <div className='col'><span className='text-info' style={{fontSize:'13px'}}><b>{row.seat} </b></span> </div>

          </div>
            <div className='row'> 
                <div className='col-6' style={{width:200}}><span className='text-primary' style={{fontSize:'13px'}}>Terminal:</span></div>
                <div className='col'><span className='text-info' style={{fontSize:'13px'}}><b>{row.terminal} </b></span> </div>
                         
           </div>

           <div className='row'> 
               
               <div className='col-6' style={{width:200}}><span className='text-primary' style={{fontSize:'13px'}}>Gate/Lounge:</span></div>
               <div className='col text-info'> <span className='text-info' style={{fontSize:'13px'}}><b>{row.gate} </b></span>  </div>
               </div>
            <div className='row'> 
               <div className='col-6' style={{width:200}}>Loc. Desc.:</div>
               <div className='col'>{row.locationLost}</div>
            </div>
         
          
          </div>
        )
      }else{
        return (
          <p className='text-primary text-center' style={{fontSize:'12px'}}>NA</p>
        )
      }
    },
    formatlClaimDetailDescription:function(col,row){
      let details = (row.details)? row.details : (row.lostItemShortDescription) ? row.lostItemShortDescription + ' (found item)' :'';
      return (<div className='text-left text-info'><p className='text-info' style={{fontSize:'14px', fontWeight:500}}>{details}</p>  </div>);

    },
    /// <div className='row'>
    //<div className='col text-left text-info'><p className='text-info' style={{fontSize:'14px', fontWeight:'bold'}}>{details}</p>  </div>
    //</div>
    formatDescriptionBrandColor: function(cell,row){
      
      try{
        let brand = (row.brand) ? row.brand : '';
        let color =(row.color) ? row.color : '';
        //let details = (row.details)? row.details : (row.lostItemShortDescription) ? row.lostItemShortDescription + ' (found item)' :'';
        let category = (row.category)? row.category : '';
        return(
         
            <div>
             
              <div className='row'> 
              <div className='col-12 text-left text-primary' style={{fontSize:'12px', fontWeight:'bold'}}>Category:<span className='text-info' style={{fontSize:'12px', fontWeight:'bold'}}>{category}</span> </div>
              </div>
              <div className='row'> 
              <div className='col-12 text-left text-primary' style={{fontSize:'12px', fontWeight:'bold'}}>Color:  <span className='text-info' style={{fontSize:'12px', fontWeight:'bold'}}>{color}  </span></div>
              </div>
              <div className='row'> 
              <div className='col-12 text-left text-primary' style={{fontSize:'12px', fontWeight:'bold'}}>Brand:  <span className='text-info' style={{fontSize:'12px', fontWeight:'bold'}}>{brand} </span> </div>
            </div>
            
            </div>
        
        )

      }catch(e){
        return(
          null
        )
      }
     
    },
    formatBoolean:function(value){
      try {
        return (
          (value) ? 'YES' : 'NO'
        )
      } catch (e) {
        return 'ERR';
      }
    }

      

}

export default ClaimHelpers;